import { Grid, Typography } from '@material-ui/core'
import Image from 'next/image'
import Flickity from 'react-flickity-component'
import styled from 'styled-components'
import { irem, rem } from '../../utils'

export const StyledCardDesignImageContainer = styled.div`
  width: 100%;
  position: relative;
  border-radius: 12px 12px 0 0;
  overflow: hidden;

  > div {
    position: relative !important;
    height: 100%;
    width: 100%
  }
`

export const StyledImage = styled(Image)`
  width: 100%;
  height: 100%;
  position: relative !important;
  object-fit: cover;
  transition: all 0.5s ease;
`

export const StyledTitle = styled(Typography)`
  margin-top: 0;
  font-size: ${props => props.theme.typography.pxToRem(20)};
  font-weight: 600;
  line-height: 1.4;
  text-align: left;
  max-height: ${props => props.theme.typography.pxToRem(190)};
  margin-bottom: 0;
  color: ${props => props.theme.palette.secondary.dark};

  ${props => props.theme.breakpoints.up('sm')} {
    margin-top: 0;
    font-size: ${props => props.theme.typography.pxToRem(24)};
    text-align: left;
    overflow-y: auto;
  }
    
  ${props => props.theme.breakpoints.up('md')} {
      font-size: ${props => props.theme.typography.pxToRem(21)};
      
      [data-columns="4"] & {
          font-size: ${props => props.theme.typography.pxToRem(19)};
      }
  }
`

export const StyledCarouselItemContainer = styled(Grid)`
  width: 100%;
  position: relative;
  flex: 1;
    
  .MuiButton-text {
    transition: color 0.1s ease-in-out;
  }

  &:hover {
    cursor: pointer;
      
      
    ${StyledTitle},
    .MuiButton-text {
      color: #bd3200;
    }

    ${StyledImage} {
      transform: scale(1.05);
    }
  }

  ${props => props.theme.breakpoints.up('sm')} {
    width: calc(50% + ${irem(30 / 2)});
  }

  ${props => props.theme.breakpoints.up('lg')} {
    width: ${props => props.theme.typography.pxToRem(467)};
  }
`
export const StyledCardBody = styled.div.attrs({ ['data-same-height']: true })`
  padding-top: ${props => props.theme.typography.pxToRem(35)};
  padding-bottom: ${props => props.theme.typography.pxToRem(35)};
  padding-left: ${props => props.theme.typography.pxToRem(40)};
  padding-right: ${props => props.theme.typography.pxToRem(40)};
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: ${props => props.theme.typography.pxToRem(20)};

  ${props => props.theme.breakpoints.up('sm')} {
    padding-top: ${props => props.theme.typography.pxToRem(35)};
    padding-bottom: ${props => props.theme.typography.pxToRem(35)};
    padding-left: ${props => props.theme.typography.pxToRem(40)};
    padding-right: ${props => props.theme.typography.pxToRem(40)};
  }

  > .card-cta {
    padding-left: 0;
    justify-self: flex-end;
    align-self: flex-start;
    text-decoration: none;
    margin-top: auto;
  }
`

export const StyledDate = styled(Typography)`
  font-size: ${props => props.theme.typography.pxToRem(14)};
  padding-top: ${props => props.theme.typography.pxToRem(0)};
  font-weight: 500;
  text-align: left;

  ${props => props.theme.breakpoints.up('sm')} {
    font-size: ${props => props.theme.typography.pxToRem(15)};
    padding-top: ${props => props.theme.typography.pxToRem(0)};
    text-align: left;
  }
`


export const StyledLinkTitle = styled.a`
  display: block;
  text-decoration: none;
  width: 100%;
  color: ${props => props.theme.palette.text.primary};
  padding-bottom: ${irem(0)};
  margin-bottom: auto;
  background: ${props => props.theme.custom.colors.grey};
  border-radius: ${props => props.theme.typography.pxToRem(12)};

  ${props => props.theme.breakpoints.up('sm')} {
    padding-left: 0;
    padding-right: 0;
  }

  &:hover {
    cursor: pointer;

    > ${StyledTitle} {
      color: ${props => props.theme.palette.secondary.main};
    }
  }
`

export const StyledDescription = styled(Typography)`
  text-align: left;
  padding-top: ${props => props.theme.typography.pxToRem(23)};
  max-height: ${props => props.theme.typography.pxToRem(190)};
  display: -webkit-box;
  -webkit-line-clamp: 3; /* Specifies the maximum number of lines */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis; /* Adds "..." to truncated text */
  margin: 0;
  padding: 0;

  ${props => props.theme.breakpoints.up('sm')} {
    text-align: left;
  }
`

export const StyledNavigationContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-bottom: ${props => props.theme.typography.pxToRem(40)};

  ${props => props.theme.breakpoints.up('sm')} {
      margin-bottom: ${irem(50)};
  }
`

export const StyledFlickityNavigation = styled.div`
  display: none;
  margin-left: auto;
  margin-top: 0;
  gap: 7px;
  position: relative;

  ${props => props.theme.breakpoints.up('sm')} {
      display: flex;
  }

  button {
    color: ${props => props.theme.palette.text.primary};
    background: none;
    font-size: ${props => props.theme.typography.pxToRem(18.5)};
    cursor: pointer;
    border: 1px solid currentColor;
    border-radius: ${props => props.theme.typography.pxToRem(5)};
    padding: ${props => props.theme.typography.pxToRem(14)} ${props => props.theme.typography.pxToRem(26)};
    line-height: 1;
    display: flex;
    align-items: center;
    transition: border 0.15s ease-in-out;
      
    &:hover {
        &:not([disabled]) {
            color: ${props => props.theme.custom.colors.darkRed};
            svg {
                fill: ${props => props.theme.custom.colors.darkRed};
            }
        }
    }
  }
`

export const StyledFlickityComponent = styled(Flickity) <{ $columns: number; $hasNavigation: boolean }>`
  position: relative;
  outline: none;
  width: 100%;
  padding-bottom: ${props => props.theme.typography.pxToRem(48)} !important;

  .flickity-button {
    display: none;

    &:disabled {
      opacity: 0.3;
      cursor: auto;
      pointer-events: none;
    }
  }

  ${props => props.theme.breakpoints.up('sm')} {
    .flickity-prev-next-button {
      top: ${props => props.theme.typography.pxToRem(0)};
      width: ${props => props.theme.typography.pxToRem(90)};
      height: ${props => props.theme.typography.pxToRem(90)};
      padding: ${props => props.theme.typography.pxToRem(28)};
      border-radius: 50%;
      box-shadow: unset;
      transform: translateY(0);
      border: 1px solid currentColor;
      -webkit-backface-visibility: hidden;
      background: none;

      & > svg {
        width: ${props => props.theme.typography.pxToRem(25)};
        height: ${props => props.theme.typography.pxToRem(25)};
      }

      &:focus {
        outline: ${props => props.theme.typography.pxToRem(1)} auto -webkit-focus-ring-color;
      }
    }

    .previous {
      left: 0;
      ${props => props.theme.breakpoints.up('md')} {
        left: ${props => props.theme.typography.pxToRem(-153)};
      }
    }

    .next {
      right: ${props => props.theme.typography.pxToRem(0)};
      ${props => props.theme.breakpoints.up('md')} {
        right: ${props => props.theme.typography.pxToRem(-153)};
      }
    }
  }

  ${props => props.theme.breakpoints.up('md')} {
    .flickity-button {
      display: ${props => props.$hasNavigation ? 'block' : 'none'};
      position: absolute;
      color: ${props => props.theme.palette.text.primary};

      &:hover {
        cursor: pointer;
        color: ${props => props.theme.palette.primary.main};

        > .flickity-button-icon {
          fill: ${props => props.theme.palette.primary.main};
        }
      }
    }
  }

  .flickity-viewport {
    overflow: visible;

    &:focus {
      outline: 0 !important;
    }

    .flickity-slider {
      height: 100%;
      display: flex;
      justify-content: center;
      margin-left: ${props => props.theme.typography.pxToRem(0)};
      margin-right: ${props => props.theme.typography.pxToRem(0)};

      ${props => props.theme.breakpoints.up('sm')} {
        > ${StyledCarouselItemContainer} {
          padding-left: ${props => props.theme.typography.pxToRem(0)};
          padding-right: ${props => props.theme.typography.pxToRem(30)};
        }
      }

      ${props => props.theme.breakpoints.up('md')} {
        > ${StyledCarouselItemContainer}:nth-child(odd), ${StyledCarouselItemContainer}:nth-child(even) {
          padding-left: ${props => props.theme.typography.pxToRem(0)};
          padding-right: ${props => props.theme.typography.pxToRem(41)};
        }
      }

      ${StyledCarouselItemContainer} {
        opacity: 0;
        ${props => props.theme.breakpoints.up('md')} {
          :last-child {
              margin-right: ${props => props.theme.typography.pxToRem(-41)};
          }  
          opacity: 1;
        }
      }

      ${StyledCarouselItemContainer}.is-selected {
        opacity: 1;
      }
    }
  }

  .flickity-page-dots {
    position: absolute;
    width: 100%;
    display: ${props => props.$hasNavigation ? 'block' : 'none'};
    left: 50%;
    right: 0;
    padding: 0;
    list-style: none;
    text-align: center;
    line-height: 1;
    transform: translateX(-50%);
    margin-top: ${props => props.theme.typography.pxToRem(23)};
      
    ${props => props.theme.breakpoints.up('sm')} {
      display: none;
    }

    li {
      margin: 0;

      &::before {
        display: none;
      }
    }

    .dot {
      display: inline-block;
      width: ${props => props.theme.typography.pxToRem(9)};
      height: ${props => props.theme.typography.pxToRem(9)};
      margin: 0 ${props => props.theme.typography.pxToRem(5)};
      background: #d9d9d9;
      border-radius: 50%;
      cursor: pointer;

      &.is-selected {
        color: ${props => props.theme.palette.primary.main};
        background: transparent;
        border: 2px solid ${props => props.theme.palette.primary.main};
      }
    }
  }
`

const columnPaddingMapping = {
  2: 20,
  3: 13,
  4: 10,
} as const

export const StyledCarouselContainer = styled.div<{ $columns?: 2 | 3 | 4; $overflow?: boolean }>`
  width: 100%;
  padding-bottom: 0;

  ${props => props.theme.breakpoints.up('md')} {
    padding-bottom: 0;

    ${StyledCarouselItemContainer} {
      ${props => props.theme.breakpoints.up('sm')} {
          width: calc(${props => 100 / (Number(props.$columns ?? 3) - (props.$overflow ? 0.5 : 0))}% + ${props => rem(columnPaddingMapping[props.$columns ?? 3], props.theme)});
      }
    }
  }

  // If we're at the min number of columns then you don't need the nav buttons
  &[data-items="1"],
  &[data-items="2"],
  &[data-items="3"]:not([data-columns="2.5"]),
  &[data-columns="4"][data-items="4"] {
    ${props => props.theme.breakpoints.up('md')} {
      ${StyledNavigationContainer} {
        justify-content: flex-start;
      }
      
      ${StyledFlickityNavigation} {
        display: none;
      }
    }
  }
`